// Import the functions you need from the SDKs you need
import 'firebase/firestore'
import 'firebase/auth'
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { GoogleAuthProvider } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBo2IGb5a8yfzaeAY7mbqLHdMe8RuGYi_g",
    authDomain: "react-journal-app-a462a.firebaseapp.com",
    projectId: "react-journal-app-a462a",
    storageBucket: "react-journal-app-a462a.appspot.com",
    messagingSenderId: "793011188597",
    appId: "1:793011188597:web:d84212051dc1911e0ed93c"
}

// Initialize Firebase
initializeApp(firebaseConfig);

const db = getFirestore()

const googleAuthProvider = new GoogleAuthProvider()

export { db, googleAuthProvider }